<template>
    <div class="container-fluid">
        <loading :active.sync="bool_fullLoading"></loading>

        <div class="pageHeader">
            <h2 id="titleHeight">{{ this.getUserInfo.DN }}'s {{this.getLanguage["PF"]["PS"]}}</h2>
        </div>

        <div class="contentWrapper">
            <div class="row m-4">
                <div class="col-md-12">
                    <!--<div class="form-group row py-2">
                        <div class="col-sm-12">
                            <h3 class="font-weight-bold mb-0">{{this.getLanguage["PF"]["PI"]}}</h3>
                            <small>{{this.getLanguage["PF"]["PD"]}}</small>
                        </div>
                    </div>
                    <div class='subHeaderHR'></div>-->

                    <div class="form-group row py-2">
                        <label class="col-sm-4 col-form-label">{{getLanguage['AG']['UDN']}}</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" :placeholder="getLanguage['AG']['UDN']" v-model="obj_P.DN">
                            <span class="ErrMsg">{{ ValidationErrMsg('DN', 'UDN') }}</span>
                        </div>
                    </div>
                    <div class='subHeaderHR'></div>
                    <div class="form-group row py-2">
                        <label class="col-sm-4 col-form-label">{{getLanguage['AG']['OP']}}</label>
                        <div class="col-sm-8">
                            <input type="password" class="form-control" :placeholder="getLanguage['AG']['OP']" v-model="obj_P.OP">
                            <span class="ErrMsg">{{ ValidationErrMsg('OP', 'OP') }}</span>
                        </div>
                    </div>
                    <div class='subHeaderHR'></div>
                    <div class="form-group row py-2">
                        <label class="col-sm-4 col-form-label">
                            {{getLanguage['AG']['UUP']}} <div class="custom_tooltip" style="position: unset;">
                                <i class="fa fa-question-circle"></i>
                                <span class="tooltiptext" style="width: 350px; left: unset; margin-left: -10%">{{getLanguage["AG"]["UPF"]}}</span>
                            </div>
                        </label>
                        <div class="col-sm-8">
                            <input type="password" class="form-control" :placeholder="getLanguage['AG']['UUP']" v-model="obj_P.UP">
                            <span class="ErrMsg">{{ ValidationErrMsg('UP', 'UUP') }}</span>
                        </div>
                    </div>
                    <div class='subHeaderHR'></div>

                    <div class="form-group row py-2">
                        <label class="col-sm-4 col-form-label">{{getLanguage['AG']['UCUP']}}</label>
                        <div class="col-sm-8">
                            <input type="password" class="form-control" :placeholder="getLanguage['AG']['UCUP']" v-model="obj_P.CUP">
                            <span class="ErrMsg">{{ ValidationErrMsg('CUP', 'UCUP') }}</span>
                        </div>
                    </div>
                    <div class='subHeaderHR'></div>

                    <div class="form-group row py-2">
                        <label class="col-sm-4 col-form-label">{{getLanguage['AG']['UE']}}</label>
                        <div class="col-sm-8">
                            <input type="email" class="form-control" :placeholder="getLanguage['AG']['UE']" v-model="obj_P.E">
                            <span class="ErrMsg">{{ ValidationErrMsg('E', 'UE') }}</span>
                        </div>
                    </div>
                    <div class='subHeaderHR'></div>

                    <div class="form-group row py-2">
                        <label class="col-sm-4 col-form-label">{{getLanguage['AG']['UPN']}}</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" :placeholder="getLanguage['AG']['UPN']" v-model="obj_P.PN">
                        </div>
                    </div>

                    <div style="margin:20px 0;text-align:center">
                        <CButton color="info" block @click="saveProfile()">
                            <span class='plusIcon cil-plus'></span>
                            {{this.getLanguage["BTN"]["SV"]}}
                        </CButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import { required, sameAs, requiredIf, minLength, email } from "vuelidate/lib/validators";
    import genericHelper from "@/modules/GenericHelper.js";
    import Loading from "vue-loading-overlay";
    import 'vue-loading-overlay/dist/vue-loading.css';

    function validatePassword(value) {
        if (this.obj_P.UP != null && this.obj_P.UP != '') {

            var pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$%^&+=!])[A-Za-z\d@#$%^&+=!]{6,32}$/;

            return pattern.test(this.obj_P.UP);
        }
        return true;
    }

    export default {
        mixins: [genericHelper],
        components: {
            Loading
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkMenuAccess', 'checkModuleAccess']),
        },
        data() {
            return {
                bool_CV: false, // Check Validation
                bool_fullLoading: false,
                obj_P: {},
            }
        },
        validations: {
            obj_P: {
                U: { required },
                DN: { required },
                E: { email },
                OP: {
                    required: requiredIf(function (vm) {
                        return vm.UP != '';
                    }),
                },
                UP: {
                    minLength: value => !value || minLength(6)(value), validatePassword
                },
                CUP: {
                    required: requiredIf(function (vm) {
                        return vm.I == 0;
                    }),
                    sameAsPassword: sameAs(function (vm) { return vm.I == 0 || (vm.UP != '' && vm.UP != null) ? vm.UP : vm.CUP; })
                }
            },
        },
        methods: {
            ...mapActions('UserInfo', ['setUser']),
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {

                    var validateObj = this.$v.obj_P[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.sameAsPassword != undefined && !validateObj.sameAsPassword) {
                        return this.getLanguage['ERR']['3001'];
                    }
                    else if ((validateObj.minLength != undefined && !validateObj.minLength) || (validateObj.maxLength != undefined && !validateObj.maxLength)) {
                        if (value == "UP") {
                            return this.getLanguage['AG']['IUPF'];
                        }
                        else {
                            return this.getLanguage['PF']['ERRMIN'];
                        }
                    }
                    else if (validateObj.email != undefined && !validateObj.email) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.minValue != undefined && !validateObj.minValue) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.validatePassword != undefined && !validateObj.validatePassword) {
                        return this.getLanguage['AG']['IUPF'];
                    }
                }
            },
            getProfile() {
                this.bool_fullLoading = true;
                var that = this;
                this.getDataApi(`/api/agt/g/0`, function (d, s) {
                    that.bool_fullLoading = false;
                    if (s) {
                        that.setProfileData(d.D);
                    }
                });
            },
            setProfileData(data) {
                var agi;
                this.obj_P = data;
                this.obj_P.UP = '';

                agi = (this.obj_P.AT == 4) ? this.obj_P.SAGAGI : this.obj_P.AGI;
                this.obj_P.ATAGI = this.obj_P.AT + "-" + agi;
            },
            saveProfile() {
                this.bool_CV = true;
                this.$v.obj_P.$touch();
                if (!this.$v.obj_P.$error) {
                    this.bool_fullLoading = true;
                    var that = this;
                    this.obj_P.IPF = 1;
                    this.postDataApi(`/api/agt/s`, this.obj_P, function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.getProfile();
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                        }
                    });
                }
            }
        },
        created() {
            this.getProfile();
        }

    }

</script>

<style>
    .contentWrapper {
        background: #fff;
        width: 100%;
        margin-top: 1rem;
        margin-left: -15px;
        margin-right: -15px;
    }


    .col-form-label {
        font-weight: bold;
    }

    .affiliateBoard {
        background: #f6f5fd;
        border-radius: 10px;
        border: solid 1px #ced2d8;
    }

    .affiliateTable {
        width: 100%;
        height: 350px;
        display: flex;
    }

        /* width */
        .affiliateTable > ::-webkit-scrollbar {
            width: 8px;
            height: 8px;
        }

        /* Track */
        .affiliateTable > ::-webkit-scrollbar-track {
            background: #f1f1f1;
        }

        /* Handle */
        .affiliateTable > ::-webkit-scrollbar-thumb {
            background: #bbbbbb;
            border-radius: 10px;
        }

            /* Handle on hover */
            .affiliateTable > ::-webkit-scrollbar-thumb:hover {
                background: #555;
            }
</style>



// WEBPACK FOOTER //
// src/components/Page/Profile.vue